import { ApiGetCompanyList, ApiGetLocationList, ApiGetUserCompanyList } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, PageTypeGetPaged } from "utils/Constant";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard(){
    const navigate = useNavigate()

    const{ data: locationList, fetch: getLocationList } = useFetch(ApiGetLocationList)
    const{ data: companyList, fetch: getCompanyList } = useFetch(ApiGetUserCompanyList)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)

    const companyClick = (companyId, companyName) => {
        localStorage.setItem("CompanyName", companyName)
        localStorage.setItem("CompanyId", companyId)

        window.location.href = "/company/dashboard"
    }

    // useEffect(() => {
    //     setLoading({isOpen: true})

    //     fGetCompanyList().then(() => {
    //         setLoading({isOpen: false})
    //     })
    //     // Promise.all([
    //     //     fGetLocationList()
    //     // ]).then((res) => {
    //     //     setLoading(false)
    //     // })
    // }, [])

    // Api Function
    async function fGetCompanyList(){
        await getCompanyList({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){

            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fLocationClick(locationId, locationName){
        localStorage.setItem("LocationId", locationId)
        localStorage.setItem("LocationName", locationName)
        
        window.location.href = "/location/transaction"
    }

    return(
        <div>
{/*             
            <div className="border rounded-md w-full p-4 shadow-md bg-white">
                <span className="text-2xl font-semibold">Company</span>
                <hr />
                <div className="mt-4 flex flex-wrap gap-4 justify-center sm:justify-start">
                    
                </div>
                
            </div> */}

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}